export default "__VITE_ASSET__Ca$JJEzH__"